import {
  ContentLayout,
  HeaderBreadcrumbs,
  CustomDetailsList,
  Loader,
  CustomeDialog,
  usePermission,
} from "../../../shared";
import * as React from "react";
import { Button, Box, Stack, Typography, Divider, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { useBirthdayCouponsV2 } from "../hooks";
import {
  BirthdayCouponActiveCustomersV2,
  BirthdayCouponUsageHistoryV2,
} from "../components";
import { LedgerAccountsList } from "../../Configurations/components";

const birthdayCouponStatusConfig = {
  2: {
    label: "Active",
    color: "success",
    variant: "outlined",
    sx: { border: "none !important" },
  },
  3: {
    label: "Paused",
    color: "success",
  },
};

export const BirthdayCouponDetailPageV2 = () => {
  const { state, handlePlayPauseStatus, handleStatusModal } =
    useBirthdayCouponsV2();
  const navigate = useNavigate();
  const isPublishAction = state.statusModalType === "publish";
  const statusConfig = birthdayCouponStatusConfig[state.couponData?.active];

  const isEditable = usePermission("coupon-modify");

  const columns = [
    {
      title: "Name",
      accessor: "name",
      header: () => {
        return (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              height="83px"
              p="32px 24px"
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="160px"
              >
                Details
              </Typography>
            </Stack>
            <Divider />
          </>
        );
      },
    },
    {
      title: "Label",
      accessor: "label",
    },
    {
      title: "Coupon Code",
      accessor: "coupon_code",
    },
    {
      title: "Description",
      accessor: (row) => {
        return <div>{row?.description && parse(row?.description)}</div>;
      },
    },
    {
      title: "Images",
      accessor: (row) => {
        return (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
          >
            <Box
              sx={{
                width: "200px",
                height: "200px",
                borderRadius: 1,
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "200px",
                  maxHeight: "200px",
                  objectFit: "cover",
                }}
                alt="img"
                src={row.mobile_image}
              />
            </Box>
            <Box
              sx={{
                width: "400px",
                height: "200px",
                borderRadius: 1,
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "200px",
                  maxHeight: "200px",
                  objectFit: "cover",
                }}
                alt="img"
                src={row.desktop_image}
              />
            </Box>
          </Stack>
        );
      },
    },
    {
      title: "Days Before",
      accessor: "start_before_days",
      header: () => {
        return (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              height="83px"
              p="32px 24px"
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="160px"
              >
                Availability
              </Typography>
            </Stack>
            <Divider />
          </>
        );
      },
    },
    {
      title: "Days After",
      accessor: "end_before_days",
    },
    {
      title: "Discount Type & Amount",
      accessor: (row) => {
        return row.discount_type === 2
          ? `Percentage - ${row.discount_amount}%`
          : `Fixed Amount - ${row.discount_amount}`;
      },
      header: () => {
        return (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              height="83px"
              p="32px 24px"
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="160px"
              >
                Action Type
              </Typography>
            </Stack>
            <Divider />
          </>
        );
      },
    },
    {
      title: "Rule Type",
      header: () => {
        return (
          <>
            {" "}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              height="83px"
              p="32px 24px"
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="160px"
              >
                Rules
              </Typography>
            </Stack>
            <Divider />
          </>
        );
      },
      accessor: (row) => (row.condition_type === 1 ? "AND" : "OR"),
    },
    {
      title: "Rules",
      accessor: (row) => {
        const rules = row.conditions;
        return (
          <div>
            <>
              <Box>
                {rules?.map((data) => {
                  return (
                    <Chip
                      component="a"
                      href={`/coupon-rules/edit/${data.id}`}
                      sx={{ mr: 1, borderRadius: "8px", cursor: "pointer" }}
                      label={data.name}
                      variant="filled"
                      size="small"
                      clickable
                    />
                  );
                })}
              </Box>
            </>
          </div>
        );
      },
    },
    {
      title: "Maximum Product Qty",
      accessor: "applicable_max_product_qty",
      hidden: (val) => {
        return !val.conditions.some((v) => v.scope == 3);
      },
    },
  ];
  const tabs = React.useMemo(() => {
    return [
      {
        label: "Details",
        value: "1",
        panel:
          state.isLoading == true ? (
            <Loader />
          ) : (
            <CustomDetailsList columns={columns} data={state.couponData} />
          ),
      },
      {
        label: "Usage History",
        value: "3",
        panel: <BirthdayCouponUsageHistoryV2 couponId={state.couponData?.id} />,
      },
      {
        label: "Active Customers",
        value: "2",
        panel: (
          <BirthdayCouponActiveCustomersV2
            couponStatus={state.couponData?.active}
          />
        ),
      },
      {
        label: "Accounts",
        value: "4",
        panel: (
          <LedgerAccountsList type="promotion" b_id={state.couponData?.id} />
        ),
      },
    ];
  }, [state]);
  return (
    <>
      <ContentLayout
        title="Birthday Promotion"
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[
              { name: "Dashboard", href: "/" },
              { name: "Birthday Coupons", href: "/birthday-coupons-v2" },
            ]}
          />
        }
        chipType="other"
        statusContent={
          statusConfig && (
            <Chip
              label={statusConfig.label}
              color={statusConfig.color}
              variant={statusConfig.variant}
              size="small"
              sx={statusConfig.sx}
            />
          )
        }
        rightContent={
          <>
            {isEditable && state.couponData?.active === 3 && (
              <img
                onClick={() => handleStatusModal("publish", true)}
                src="/icons/ic_play_blue2.svg"
                style={{
                  cursor: "pointer",
                }}
              />
            )}
            {isEditable && state.couponData?.active === 2 && (
              <Button
                aria-label="pause"
                color="primary"
                type="button"
                size="medium"
                variant="text"
                sx={{
                  minWidth: "40px",
                  p: "8px",
                }}
                disabled={state.isSaveButtonBusy}
              >
                <img
                  onClick={() => handleStatusModal("unpublish", true)}
                  src="/icons/play_icon.svg"
                />
              </Button>
            )}
            {isEditable && (
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={() => navigate("/birthday-coupons-v2/edit")}
              >
                Edit
              </Button>
            )}
          </>
        }
        tabProps={{
          label: "birthdayCouponsV2",
          list: tabs,
        }}
      />

      <CustomeDialog
        open={state.statusModalOpen}
        PaperProps={{
          sx: {
            width: "423px",
            height: "150px",
            p: "16px",
            gap: "12px",
          },
        }}
        title={isPublishAction ? "Publish Coupon" : "Unpublish Coupon"}
        content={
          <>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height="100%"
            >
              <Typography fontSize="14px" fontWeight={400} lineHeight="16px">
                {isPublishAction
                  ? "Are you sure you want to publish this Birthday Coupon?"
                  : "Are you sure you want to unpublish this Birthday Coupon?"}
              </Typography>
              <Box display="flex" justifyContent="flex-end" mt="auto" gap={1.5}>
                <Button
                  size="small"
                  variant="text"
                  color="info"
                  onClick={() =>
                    handleStatusModal(state.statusModalType, false)
                  }
                >
                  No
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  disabled={state.isSaveButtonBusy}
                  onClick={() => {
                    handlePlayPauseStatus();
                    handleStatusModal(state.statusModalType, false);
                  }}
                >
                  Yes
                </Button>
              </Box>
            </Box>
          </>
        }
      />
    </>
  );
};
